<template>
  <v-row no-gutters align="center">
    <v-col cols="auto" v-bind="$attrs" v-on="$listeners">
      <template v-if="hasPatientRisks">
        <v-icon
          v-for="patientRisk in patientRisks"
          :key="patientRisk.id"
          :color="colorForPatientRisk(patientRisk)"
          :dark="isDarkPatientRisk(patientRisk)"
          small
        >
          mdi-checkbox-blank-circle
        </v-icon>
      </template>

      <v-icon small v-else>mdi-information</v-icon>
    </v-col>
  </v-row>
</template>

<script>
import {
  colorForPatientRisk,
  isDarkPatientRisk,
} from "@/components/queues/attendance/patient_risk/colors.js";

export default {
  name: "PatientRiskIndicators",
  props: {
    patientRisks: {
      type: Array,
      required: true,
    },
  },
  computed: {
    hasPatientRisks() {
      return this.patientRisks.length > 0;
    },
  },
  methods: {
    colorForPatientRisk(patientRisk) {
      return colorForPatientRisk(this.$Color(), patientRisk);
    },
    isDarkPatientRisk(patientRisk) {
      return isDarkPatientRisk(this.$Color(), patientRisk);
    },
  },
};
</script>

<style></style>
